import { browserUtil } from '../util/browser-util'
import { tokenService } from './token-service'

export const authService = {
  logout: async (): Promise<void> => {
    await tokenService.clear()
    browserUtil.redirect('/auth/')
  },
}
